export enum InternshipSalaryEnum {
  Profile = 'profile',
  Yes = 'yes',
  No = 'no',
}

export const Salary: Record<InternshipSalaryEnum, string> = {
  [InternshipSalaryEnum.Profile]: 'Selon profil',
  [InternshipSalaryEnum.Yes]: 'Oui',
  [InternshipSalaryEnum.No]: 'Non',
};
